import React, { Component } from 'react'
import { Datagrid, DateField, DeleteButton, List, TextField } from 'react-admin'

class InvitationList extends Component {
  render() {
    return (
      <List {...this.props} sort={{ field: 'invitee.email', order: 'ASC' }} exporter={false}>
        <Datagrid rowClick="edit">
          <TextField source="invitee.email" label="To" />

          <DateField
            source="created_at"
            locales="nl-BE"
            showTime
            options={{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: false,
            }}
          />

          <DateField
            source="expires_at"
            label="Expire at"
            locales="nl-BE"
            showTime
            options={{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: false,
            }}
          />

          <DeleteButton />
        </Datagrid>
      </List>
    )
  }
}

export default InvitationList
